















































import { Component } from 'vue-property-decorator';

import basePagination from '@/components/BasePagination/BasePagination.vue';
import { HeaderList } from '@/components/Table/TableModel';

import FlexButton from '@/components/FlexButton/FlexButton.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

import RowsTable from '@/components/Table/RowsTable.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';

import AdminService from '@/api/AdminService';

import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import { treatValue } from '@/utils/moneyTreatments';

import { ICampaign } from './CampaignsListType';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';

@Component({
  components: {
    FlexButton,
    Table,
    RowsTable,
    Checkbox,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon
  }
})
export default class CampaingnsList extends basePagination {
  service: AdminService = new AdminService();

  newCampaingnModal() {
    const modalConfig = {
      isOpen: true,
      component: 'newCampaingnModal'
    };

    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  mounted() {
    eventBus.$on('reloadCampaignList', () => this.reloadList(true));
  }

  beforeDestroy() {
    eventBus.$off('reloadCampaignList');
  }

  get campaignStatus() {
    return {
      getter: (campaign: ICampaign) => {
        return campaign.status === 'active';
      },
      setter: async (campaign: ICampaign) => {
        this.$showLoaderWithLocker();
        const { id } = campaign;
        const { actualActive, item, index } = this.findById(id);
        const status = item.status;

        if (index !== null) {
          this.toggle(index);
          this.deactive(id);

          const response = await this.service
            .setCampaignStatus(id, {
              status: this.getOtherStatus(status)
            })
            .finally(() => this.$hideLoader());

          if (response && response.status === 200) {
            this.$hideLoader();
            this.$notification('Campaign status has been updated', 'success');
          } else {
            this.toggle(index);
            this.toggle(actualActive);
            this.$hideLoader();
          }
        } else {
          this.$hideLoader();
          this.$notification(
            'Campaign not found, please try again later.',
            'error'
          );
        }
      }
    };
  }

  findById(id: string) {
    let index!: number;
    let item!: ICampaign;
    let actualActive!: number;
    this.dataList.list.forEach((campaign: ICampaign, i) => {
      if (campaign.status === 'active') {
        actualActive = i;
      }

      if (campaign.id === id) {
        item = campaign;
        index = i;
      }
    });

    return { actualActive, item, index };
  }

  toggle(index: number) {
    const { status } = this.dataList.list[index];
    this.dataList.list[index].status = this.getOtherStatus(status);
  }

  getOtherStatus(status: string) {
    if (status === 'active') {
      return 'inactive';
    }

    return 'active';
  }

  deactive(exceptionId?: string) {
    const { list } = this.dataList;
    this.dataList.list = list.map((campaign: ICampaign) => {
      if (campaign.id !== exceptionId) {
        campaign.status = 'inactive';
      }

      return campaign;
    });
  }

  initHeader() {
    return [
      new HeaderList(`Name`, 'none'),
      new HeaderList(`Created`, 'none'),
      new HeaderList(`Active Time`, 'none'),
      new HeaderList(`Total Coins`, 'none'),
      new HeaderList(`Rewarded Coins`, 'none'),
      new HeaderList(`New Users`, 'none'),
      new HeaderList(`Coins waiting to be rewarded`, 'none'),
      new HeaderList(`Status`, 'none')
    ];
  }

  addRowsList(data: any[]): any[] {
    let rows: any[] = [];
    data.forEach((row: any) => {
      rows.push({
        id: row.id,
        name: row.name,
        created: DateUtils.formatISODate(row.createdAt),
        activeTime: DateUtils.formatSeconds(row.activeTime) || 'None',
        totalRewardCoins: treatValue(row.coinsReward),
        rewardedCoins: treatValue(row.coinsRewarded),
        registrations: row.registrations,
        waitingRewardCoins: treatValue(row.coinsWaitingReward),
        status: row.status
      });
    });

    return rows;
  }

  async reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string
  ) {
    if (clearList) {
      this.resetPagination();
      this.dataList.list = [];
      this.maxItems = false;
    }

    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;

    try {
      const response = await this.service.getCampaigns(this.pagination);
      const { data } = response;
      const { items, links } = data;
      if (refreshCurrent) {
        // refresh page and reinitilize pagination
        this.resetPagination();
        this.pagination = links.next;
        if (!links.next) this.maxItems = true;
        this.dataList.list = this.addRowsList(items);
      } else {
        // refresh page and add items
        if (!links.next) this.maxItems = true;
        this.pagination = links.next;
        this.dataList.list = this.dataList.list.concat(this.addRowsList(items));
      }

      this.$hideLoader();
      this.isLoading = true;
      this.refreshing = false;
    } catch {
      this.$hideLoader();
    }
  }
}
